import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { OnboardingController } from '@features/onboarding/onboarding.controller';

export const onboardingResolver: ResolveFn<boolean> = () => {
  const controller = inject(OnboardingController);
  void controller.handleOnboardingTutorialModalOpening();
  return true;
};
